import React, { createContext, useContext, useEffect, useState } from "react";
import { registerAuthModal } from "../services/CmnService";
// import axios from "axios";
// import { currencyRateURL } from "../services/CommonUrl";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const token = JSON.parse(localStorage.getItem("token_gw"));
    const user = JSON.parse(localStorage.getItem("login_gw"));
    const currency = JSON.parse(localStorage.getItem("currency_gw"));
    const [currencyData, setCurrencyData] = useState(currency || { currency: "", country: "", exchangeRate: "" });
    const [authed, setAuthed] = useState(
        token && user
            ? { isAuth: true, token, user }
            : { isAuth: false, token: "", user: {} }
    );
    const [authModal, setAuthModal] = useState(false);

useEffect(() => {
  registerAuthModal(setAuthModal);
}, [setAuthModal]);
    // console.log("authed==>", authed);
    // console.log("currency==>", currencyData);

    // useEffect(() => {
    //     axios.get(currencyRateURL + `${currencyData.currency}`).then((response) => {
    //         const exchangeRate = response.data.rates;
    //         console.log("exchangeRate===>", exchangeRate)
    //         if (exchangeRate) {
    //             setCurrencyData(prevData => ({
    //                 ...prevData,
    //                 exchangeRate: exchangeRate
    //             }));
    //         }
    //     });
    // }, []);


    return (
        <AuthContext.Provider value={{ authed, setAuthed, currencyData, setCurrencyData, authModal, setAuthModal }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext);